import React from 'react'
import './App.css';

import arrow from './assets/arrow.svg'

export default function Nav({ width, onClick, rotate }) {

  return (
    width > 1024 ?
    <div className='nav'>
          <a
            href="#about"
            className="item"
          >
            О НАС
          </a>

          <a
            href="#advantages"
            className="item"
          >
            ПРЕИМУЩЕСТВА
          </a>

          <a
            href="#app"
            className="item"
          >
            {width > 1024 && 'СКАЧАТЬ '}ПРИЛОЖЕНИЕ
          </a>
    </div>
    :
    <button className="circleNav" onClick={onClick}>
      <img className='arrow' src={arrow} alt="Кнопка отправки по якорю" style={{transform: rotate === 3 && 'none'}} />
      </button>
  )
}
